import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {getHistoryList} from "../../../redux/actions/history/actions";
import HistoryFilter from "../../components/Filter/HistoryFilter/HistoryFilter.jsx";
import HistoryList from "../../components/Tables/HistoryList.jsx";
import HistoryInfo from "../../components/HistoryInfo/HistoryInfo.jsx";
import {lobbyOpenModal} from "../../../redux/actions/lobby/actions.js";

const History = React.memo(function () {
    const isMobile = useSelector((state) => state.user.isMobile);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getHistoryList())
    }, [dispatch]);
    return isMobile
        ? <>
            <div
                className="mobile-history-filter"
            >
                <i className="icon-sort-icon" onClick={() => dispatch(lobbyOpenModal({name: 'HistoryFilterMobile'}))}/>
            </div>
            <HistoryList/>
        </>
        : <div className="history">
            <HistoryFilter/>
            <div className="history__wrapper">
                <HistoryList/>
                <HistoryInfo/>
            </div>
        </div>
})

export default History